import React from 'react';
import {Box, Typography} from "@mui/material";
import {ProductCard} from "@/components/Shop/ProductCard/ProductCard";
import {Product} from "@/store/types";
import {useTranslation} from "react-i18next";
import s from './ProductsPage.module.css'
import '../../../index.css';



type ProductsPageProps = {
    products: Product[];
    title: string;
    emptyTextKey: string;
    showRemoveButton?: boolean;
}

export const ProductsPage = ({products, title, emptyTextKey, showRemoveButton= false}: ProductsPageProps) => {
    const {t} = useTranslation();

    return (
        <div className="globalContainer">
            <Typography variant="h5" className={s.title2}>
                {t(title)}
            </Typography>
            <Box className={s.container}>
                <Box className={s.textContainer}>
                    {products.length === 0 ? (
                        <Typography className={s.emptyText}>{t(emptyTextKey)}</Typography>
                    ) : (
                        <Box className={s.productsList}>
                            {products.map((item) => (
                                <ProductCard key={item.id} product={item} showRemoveButton={showRemoveButton} />
                            ))}
                        </Box>
                    )}
                </Box>
            </Box>

        </div>
    );
};